import { Component, HostListener } from '@angular/core';
import { AuthService } from './services/auth.service';
import { DictionaryService } from './services/dictionary.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { WebsocketService } from './services/websocket.service';
import { GalleryImageService } from './services/gallery-image.service';
import { ngErrorCode } from '@angular/compiler-cli/src/ngtsc/diagnostics';
import { KioskIdService } from './services/kiosk-id.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isCollapsed = false;
  isPageLogin = false;
  openMenu = false;
  name$ = this.authService.name$;
  loginFormVisible = false;
  @HostListener("click")
  clickEvent() {
    if (this.authService.isAuthenticated()) {
      this.authService.info().subscribe();
    }
  }
  constructor(public authService: AuthService,
              private dictionaryService: DictionaryService,
              private router: Router,
              private webSocket: WebsocketService,
              private kioskService: KioskIdService,
              public galleryService: GalleryImageService) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((x) => {
      x = x as NavigationEnd;
      this.isPageLogin = !x.url.includes('login');
    });
    this.kioskService.getKioskId();
    this.initData();
  }
  initData() {
    console.log('',  this.authService.isAuthenticated$.getValue())
    if (this.authService.isAuthenticated()) {
      this.dictionaryService.init();
      // @ts-ignore
      this.authService.nameOrg = localStorage.getItem('orgName');
      this.authService.info().subscribe(x => {
        console.log('init websocket');
        this.websocketInit();
        // this.name$.next(x.ConvictedFirstName + ' ' + x.ConvictedLastName);
      });
    }
  }

  navigate(url: string) {
    this.router.navigate([url]);
    this.openMenu = false;
  }
  websocketInit() {
    console.log(this.authService.token);
    this.webSocket.init();
    this.webSocket.sendMessage({
      Event: "auth",
      Token: this.authService.token
    });
    this.webSocket.pingStart();
  }

  logout() {
    this.authService.logout();
  }

  setStateMenu() {
    this.openMenu = !this.openMenu
  }

  login() {
    this.loginFormVisible = !this.loginFormVisible;
  }

  navigateUrl(value: string) {
    if( value === 'police') {
      window.location.href = 'https://www.zakonrf.info';
    }
    if (value === 'vacantion') {
      window.location.href = 'https://irkzan.ru/vacancy';
    }
    this.router.navigate([value]);
  }
}
